import { Link } from "react-router-dom";

export const Logo = ({ to = "/" }) => (
  <Link to={to} data-testid="nav-brand-logo" className="flex items-center gap-2 group">
    <span className="relative grid place-items-center w-9 h-9 rounded-xl bg-[#2F5D4A] text-white shadow-sm transition-transform duration-200 group-hover:-rotate-6">
      <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 20l6.5-11 3.5 5.5 3-4.5L22 20z" />
        <path d="M8.5 9l1.8 3" />
      </svg>
    </span>
    <span className="font-display text-base sm:text-lg font-extrabold tracking-tight text-[#1A2B25] whitespace-nowrap">
      Bonus Thought<span className="text-[#2F5D4A]">.</span>
    </span>
  </Link>
);
